<template>
  <div>
    <a-spin :spinning="spinning">
      <div class="spin-content">        
        <a-button-group >
            <a-button
                type="primary"
                @click="handleFetch"
                style="margin-bottom: 1rem;"
            >
                載入資料
            </a-button>
            <a-button
                v-if="myData.length > 0"
                @click="exportToExcel"
                style="margin-bottom: 1rem;"
            >
                匯出 Excel 報表
            </a-button> 
        </a-button-group>        
        <b-list-group>
        <b-list-group-item v-for="item in myData" :key="item.id">
            <div>
            <div><b>角色：</b>{{ getRole(item.roles) }}</div>
            <div><b>系統帳號：</b>{{ item.username }}</div>
            <div><b>地址：</b>{{ item.address }}</div>
            <div><b>生日：</b>{{ item.birth }}</div>
            <div><b>顯示名稱：</b>{{ item.display_name }}</div>
            <div><b>註冊連絡電話：</b>{{ item.hphone }}</div>
            <div v-if="item.acts_detrimal && item.acts_detrimal.length > 0">
                <div v-for="det in item.acts_detrimal" :key="det.id" style="margin-top: 0.5em;">
                <div v-for="byrs in det.byrsoptions" :key="byrs.id">
                    <div>
                    <b>
                        {{ getMyJsonName(byrs.oid, byrs.items) }}
                    </b>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </b-list-group-item>
        </b-list-group>        
      </div>
    </a-spin>
  </div>
</template>

<script>
import * as moment from "moment/moment";
import { joinService } from "../../../_services";
import Formdatas from '../../../assets/json/formdata.json';
import { mapState } from "vuex";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import 'moment/locale/zh-tw';

const queryData = obj => {
  return joinService.GetMyJoin(obj);
};


export default {
  name: "Act_myform",
    props: {
    aid: {
        type:String,
        required: true
    }
    },   
  data() {
    return {
      spinning: false,
      myJson: Formdatas,
      myData: [],
    };
  },
  computed: {
    ...mapState("makeorg", ["defaultval"]),
  },

  methods: {
    fdateformat(val) {
      return moment(val).format("YYYY-MM-DD");
    },

    async handleFetch() {
        this.spinning = true;
        await this.fetch();
        this.spinning = false;
    },

    async fetch(params = { aid: this.aid }) {
        const { data } = await queryData({ ...params });
        this.myData = data;
    },

    mainImg(imgs) {
      return require(`../../../assets/${imgs}`);
    }, 

    getRole(val) {
        switch (val) {
        case "actor": return "參加者";
        case "broker": return "主辦單位";
        case "coach": return "講師";
        case "volunteer": return "志工";
        case "D": return "下架";
        default: return val;
        }
    },
    getMyJsonName(oid, items) {
    const obj = this.myJson.find(j => String(j.id) == String(oid));
    if (!obj) return '';
    let value = items;
    // 如果 items 是 "0912978837 (張柏騰)" 這種格式，只取電話號碼
        if (typeof items === 'string' && items.match(/^\d{8,}(?:\s*\(.+\))?/)) {
            value = items.split(' ')[0];
        }
        if (obj.list && Array.isArray(obj.list) && obj.list.length > 0) {
            // 單選
            const found = obj.list.find(l => l.value == value);
            if (found) return obj.name + '：' + found.text;
            // 多選
            if (typeof value === 'string' && value.includes(',')) {
            const texts = value.split(',').map(val => {
                const f = obj.list.find(l => l.value == val.trim());
                return f ? f.text : val.trim();
            });
            return obj.name + '：' + texts.join('、');
            }
        }
        return obj.name + '：' + items;
    },

    exportToExcel() {
        const allRows = [];
        const fieldSet = new Set();

        this.myData.forEach((item, idx) => {
            const row = { 編號: idx + 1 };

            // 固定欄位（與畫面一致，含 getRole）
            [
            ['角色', this.getRole(item.roles)],
            ['系統帳號', item.username],
            ['地址', item.address],
            ['生日', item.birth],
            ['顯示名稱', item.display_name],
            ['註冊連絡電話', item.hphone]
            ].forEach(([key, value]) => {
            row[key] = value;
            fieldSet.add(key);
            });

            // 動態欄位（byrsoptions）
            if (item.acts_detrimal && item.acts_detrimal.length > 0) {
            item.acts_detrimal.forEach(det => {
                (det.byrsoptions || []).forEach(byrs => {
                const info = this.getMyJsonName(byrs.oid, byrs.items);
                if (info && info.includes('：')) {
                    const [key, value] = info.split('：');
                    // 多值合併
                    if (row[key]) {
                    row[key] += '、' + value;
                    } else {
                    row[key] = value;
                    }
                    fieldSet.add(key);
                }
                });
            });
            }
            allRows.push(row);
        });

        // 動態補齊所有欄位
        const fields = ['編號', ...Array.from(fieldSet)];
        const excelData = allRows.map(row => {
            const obj = {};
            fields.forEach(f => {
            obj[f] = row[f] || '';
            });
            return obj;
        });

        // 匯出
        const worksheet = XLSX.utils.json_to_sheet(excelData, { header: fields });
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, '報名資料');
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(blob, '報名資料.xlsx');
        },

  }
};
</script>


<style scoped>
.myTable thead {
  background-color: #000000;
}

.highlight-score {
    background-color: #dff0d8; /* 选择一个明亮的绿色背景 */
    font-weight:bold;
}

.spin-content {
  
  padding: 30px;
}

#stats-container {
  background-color: rgb(242, 248, 227);
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 8px;
  margin: 20px;
  width: 98%;
}

#stats-container h4 {
  color: #333;
  text-align: center;
  margin-bottom: 10px;
  font-weight: bold;
}

.stat {
  margin: 10px 0;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ddd; /* 底線樣式 */
  padding-bottom: 8px; /* 增加底部間隔 */
}

.stat:last-child {
  border-bottom: none; /* 最後一個 stat 不顯示底線 */
}

.stat label {
  color: #555;
  font-weight: bold;
  margin-right: 5px;
}

.stat span {
  flex-grow: 1;
  text-align: right;
  color: #2c3e50;
}

</style>
